<div class="container" *ngIf="!loading">
  <mat-icon
    class="close-icon"
    mat-dialog-close
    mat-button
    (click)="closePopup()"
    >close</mat-icon
  >
  <!-- <pre>{{ attachmentDetails | json }}</pre> -->
  <p style="display: flex; justify-content: end;">
    {{ "Uploaded date" | translate }}:&nbsp;
    <span>
      {{ this.attachmentDetails.updatedAt | date: "longDate" : "+0:00" : pipeLanguage }}
    </span>
  </p>

  <div>
    <a
      target="_blank"
      href="{{ attachmentDetails.url }}"
      *ngIf="imageExtension == 'png' || imageExtension == 'jpg' || imageExtension == 'jpeg'"
      ><img #rotatedImage  src="{{ attachmentDetails.url }}" class="img"  [style.transform]="'rotate(' + rotation + 'deg)'" /> <br
    /></a>

    <a
      target="_blank"
      href="{{ attachmentDetails.url }}"
      *ngIf="imageExtension == 'doc' || imageExtension == 'docx'"
      ><img src="../../../assets/images/word.svg" class="img" /> <br
    /></a>

    <a
      target="_blank"
      href="{{ attachmentDetails.url }}"
      *ngIf="imageExtension == 'pdf'"
      ><img src="../../../assets/images/pdf-view.png" class="img" /> <br
    /></a>

    <a
      target="_blank"
      href="{{ attachmentDetails.url }}"
      *ngIf="
        imageExtension == 'xls' ||
        imageExtension == 'xlsx' ||
        imageExtension == 'csv'
      "
    >
      <img src="../../../assets/images/excel.svg" class="img" /> <br
    /></a>

    @if ( editAccess && !editMode ) {
      <div>
        <span
          style="
            float: right;
            color: #65a7f6;
            cursor: pointer;
            display: inline-flex;
          "
          (click)="enableEdit()"
        >
          <img src="../../../assets/images/editable.svg" />
          <span style="padding-left: 10px">{{ "Edit" | translate }}</span>
        </span>
      </div>
    }
  </div>

  @if ( !editMode ) {
    <mat-chip-grid *ngIf="this.attachmentDetails.tag">
      <mat-chip>
        {{
          this.attachmentDetails.tag.tag[currentLanguage]
            ? this.attachmentDetails.tag.tag[currentLanguage]
            : ""
        }}
      </mat-chip>
    </mat-chip-grid>
    <div style="margin: 2% 10% 10% 10%; text-align: left">
      <span class="content">
        {{
          this.attachmentDetails.description
            ? this.attachmentDetails.description
            : ""
        }}
      </span>
    </div>
  }

  @if ( editMode ) {
    <form [formGroup]="attachmentForm">
      <div style="text-align: center">
        <mat-form-field class="tag-selection">
          <mat-label>{{ "Choose a tags" | translate }}</mat-label>
          <mat-select
            formControlName="tags"
            (selectionChange)="changeTags($event.value)"
          >
            <mat-option *ngFor="let t of tags" [value]="t">{{
              t.tag[currentLanguage]
            }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <textarea
        matInput
        rows="5"
        class="textArea"
        style="resize: none; box-sizing: border-box; padding: 12px"
        formControlName="description"
      ></textarea>
    </form>
  }

  @if ( editMode && validImg.includes(imageExtension) ) {
    <div class="attach-rotate-button-row">
      <button (click)="rotateImg(-90)">
        <img src="assets/images/rotate_90_i.svg" alt="" />
        <span>Girar a la izquierda</span>
      </button>
      <button (click)="rotateImg(90)">
        <img src="assets/images/rotate_90_r.svg" alt="" />
        <span>Girar a la derecha</span>
      </button>
    </div>
  }

  @if ( !editMode ) {
    <div class="attachdone-button-row">
      <button mat-raised-button (click)="closePopup()" class="large-button-blue">
        {{ "Done" | translate }}
      </button>
    </div>
  }

  @if ( editMode ) {
    <div class="attach-button-row">
      <button mat-raised-button (click)="validate()" class="large-button-blue">
        {{ "Save" | translate }}
      </button>
    </div>
  }
</div>
